import classNames from 'classnames';
import { string } from 'prop-types';
import { ReactNode } from 'react';
import { Field } from 'react-final-form';

import css from './FieldRadioButton.module.css';

interface FieldRadioButtonComponentProps {
  id: string;
  name: string;
  value: string;
  label?: ReactNode;
  onChange?: (params: any) => void;
  className?: string;
  rootClassName?: string;
  svgClassName?: string;
  checkedClassName?: string;
  showAsRequired?: boolean;
}

const IconRadioButton = props => {
  const { checkedClassName } = props;
  return (
    <div>
      <svg className={props.className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <circle
          className={props.showAsRequired ? css.required : css.notChecked}
          cx="5"
          cy="19"
          r="6"
          transform="translate(2 -12)"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
        />

        <g
          className={classNames(css.checked, checkedClassName || css.checkedStyle)}
          transform="translate(2 -12)"
          fill="none"
          fillRule="evenodd"
        >
          <circle strokeWidth="2" cx="5" cy="19" r="6" />
          <circle fill="var(--n-color-white)" fillRule="nonzero" cx="5" cy="19" r="3" />
        </g>
      </svg>
    </div>
  );
};

IconRadioButton.defaultProps = { className: null };
IconRadioButton.propTypes = { className: string };

const FieldRadioButtonComponent = (props: FieldRadioButtonComponentProps) => {
  const {
    rootClassName,
    className,
    svgClassName,
    checkedClassName,
    id,
    label,
    showAsRequired,
    onChange: customOnChange, // We'll call this after Final Form handles changes
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Field {...rest} type="radio">
      {({ input }) => {
        const handleChange = e => {
          input.onChange(e); // Final Form's onChange
          if (customOnChange) {
            customOnChange(e); // Your custom callback
          }
        };

        return (
          <span className={classes}>
            <input {...input} id={id} type="radio" className={css.input} onChange={handleChange} />
            <label htmlFor={id} className={css.label}>
              <span className={css.radioButtonWrapper}>
                <IconRadioButton
                  className={svgClassName}
                  // @ts-expect-error TS(2322) FIXME: Type '{ className: any; checkedClassName: any; sho... Remove this comment to see the full error message
                  checkedClassName={checkedClassName}
                  showAsRequired={showAsRequired}
                />
              </span>
              <span className={css.text}>{label}</span>
            </label>
          </span>
        );
      }}
    </Field>
  );
};

FieldRadioButtonComponent.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  checkedClassName: null,
  label: null,
};

export default FieldRadioButtonComponent;
